import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=e404f9c2&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e404f9c2')) {
      api.createRecord('e404f9c2', component.options)
    } else {
      api.reload('e404f9c2', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=e404f9c2&", function () {
      api.rerender('e404f9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ay15uLUk0K6d/JS/comp/stardisplay.vue"
export default component.exports